/** P3-A7: one shared standalone-display-mode check, used by the install
 * coach, the session-bridge hint, and the idle-logout exemption. Two
 * independent signals because no single one covers every platform:
 * `display-mode: standalone` is the general PWA media query (Android
 * Chrome, desktop); `navigator.standalone` is Safari's own iOS-only flag
 * (iOS never reliably reflects display-mode via matchMedia pre-A2HS). */
export function isStandaloneDisplayMode(): boolean {
  const mediaMatch =
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia('(display-mode: standalone)').matches
      : false;
  const iosStandalone =
    typeof navigator !== 'undefined' && (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return mediaMatch || iosStandalone;
}

/** Desktop-only PWA affordances must not leak into browser or mobile shells. */
export function isDesktopStandaloneDisplayMode(isMobile: boolean): boolean {
  return !isMobile && isStandaloneDisplayMode();
}
